import GeoHelper from '../../../utils/geo-helpers.utils';
import MapLayer from '../map-layer.enum';

function addSimpleGeoJsonSource(layer: MapLayer | string, clustering = false) {
  GeoHelper.addSimpleGeoJsonSource(layer, clustering);
}

export default addSimpleGeoJsonSource;
